<template>
	<div class="newSubscription">
		<div>
			<div class="row">
				<div class="col-lg-8">
					<div class="card mb-2 roundestoreIdSelected0">
						<div class="card-body">
							<div v-for="(item, index) in listTypeSubscriptions" :key="index" class="mb-2">
								<table class="table-subscription border border-secondary">
									<tr>
										<th colspan="2">{{ item.name }}</th>
										<th class="text-center quantity">Cantidad</th>
										<th class="text-center total">Total</th>
									</tr>
									<tr v-for="(it, index) in listProducts" :key="index" v-if="it.type_subscription_id == item.id">
										<td :title="it.id">{{ it.product }}</td>
										<td class="text-end price" style="min-width:72px"><b><span class="float-start">$</span>{{ price(it) | formatNumber }}</b></td>
										<td>
											<input type="text" class="text-end input-quantity border border-dark" v-model="it.quantity"
												@focus="$event.target.select()"
												@blur="eventBlour(it)"
												:disabled="price(it) == 0">
										</td>
										<td class="text-end"><b>{{ (price(it) * it.quantity) | formatNumber }}</b></td>
									</tr>
								</table>
							</div>
							<b>* Todos los envíos son trimestrales, incluso las revistas mensuales</b>
						</div>
					</div>
					<div class="text-end d-none d-lg-block">
						<button class="btn btn-block btn-primary" data-bs-toggle="modal" data-bs-target="#resumeSubscriptionModal" :disabled="disabledBtnSaveSubscription">Continuar</button>
					</div>

				</div>
				<div class="col-lg-4 mb-4">
					<div class="card mb-2 rounded-0">
						<div class="card-body">
							<div class="title-width-icon">
								<router-link to="/profile" class="float-end text-warning icon" v-if="!getClientSystem.extras.cpil">
									<svg width="14" height="14" role="img" title="Editar información">
										<use xlink:href="#pencil-square"/>
									</svg>
								</router-link>
								<i class="float-end text-warning icon" v-else data-bs-toggle="modal" data-bs-target="#clientSendtoModal" ref="btnShowClientSendtoModal">
									<svg width="14" height="14" role="img" title="Editar información">
										<use xlink:href="#pencil-square"/>
									</svg>
								</i>
								<h5 class="card-title text-center">{{ objectClientSendto.sendto }}</h5>
							</div>
							<div  v-if="objectClientSendto.email.trim() != ''">
								<svg class="text-secondary me-2" width="14" height="14"><use xlink:href="#envelope"/></svg>
								<b class="align-middle text-secondary">{{ objectClientSendto.email }}</b>
							</div>
							<div v-if="objectClientSendto.phone.trim() != ''">
								<svg class="text-secondary me-2" width="14" height="14"><use xlink:href="#phone"/></svg>
								<b class="align-middle text-secondary">{{ objectClientSendto.phone }}</b>
							</div>
							<div class="list-group-light p-0">
								<div class="list-group-item d-flex justify-content-between align-items-center mb-1">
									<div>
										<div class="fw-bold align-middle text-secondary">
											<svg class="text-secondary me-1" width="14" height="14"><use xlink:href="#building"/></svg>
											{{ church.type_church.name }} {{ church.name }}
										</div>
										<div class="ms-4 text-secondary">Distrito: {{ church.district.name }} ({{ church.entity.synthetic }})</div>
										<p class="ms-4" v-if="getClientSystem.id != church.client_id">
											<span class="text-muted" v-if="church.client_id != undefined && church.client_id != null">
												CPIL: 
												<span v-if="church.client != null && church.client != undefined">{{ church.client.name }} {{ church.client.surname }}</span>
												<span v-else class="text-danger">No está definido</span>
											</span>
											<span class="text-danger" v-else>
												Esta Iglesia no tiene un CPIL asignado
											</span>
										</p>
									</div>
								</div>
							</div>
						</div>
						
					</div>

					<div class="card-total d-none d-lg-block" style="margin-bottom: 1rem">
						<div class="card rounded-0">
							<div class="card-body text-center">
								<h5 class="card-title">Total Suscripción</h5>
								<h4 class="card-title text-end">CLP ${{ totalSuscripcionProducts | formatNumber }}</h4>
							</div>
						</div>
					</div>
					<div class="d-grid gap-2 mb-5">
						<button class="btn btn-block btn-primary" data-bs-toggle="modal" data-bs-target="#resumeSubscriptionModal" :disabled="disabledBtnSaveSubscription">Continuar</button>
					</div>
				</div>
			</div>
			<div class="nav-total d-md-block d-lg-none">
				<nav class="navbar fixed-bottom navbar-light bg-entity bg-opacity-10 text-white">
					<div class="container-fluid pt-2 pb-2">
						<div></div>
						<h4 class="card-title" style="padding-right: 1rem">Total Suscripción CLP $ {{ totalSuscripcionProducts | formatNumber }}</h4>
					</div>
				</nav>
			</div>
		</div>

		<!-- Modal Client Sendtos-->
		<div class="modal fade" id="clientSendtoModal" data-bs-backdrop="static" yboard="false" aria-labelledby="staticBackdropLabel" aria-hidden="true" role="dialog">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content rounded-2 shadow">
      				<div class="modal-header p-4 pb-4 border-bottom-0">
        				<!-- <h5 class="modal-title">Modal title</h5> -->
        				<h4 class="fw-bold mb-0">Suscripción de:</h4>
      				</div>
					<div class="modal-body p-4 pt-0">
						<div class="text-dark">
							<div class="form-floating mb-3">
								<client-sendto-input-component msg="Nombre y Apellido"
									ref="churchsInputComponent"
									:listClientSendto="listClientSendtos"
									:searchClientSendto="false"
									@actionSelectItem="selectItemClientSendto"></client-sendto-input-component>
							</div>
							<div class="form-floating mb-3">
								<input type="text" class="form-control rounded-1" id="floatingPassword" v-model="objectClientSendto.phone">
								<label for="floatingPassword">Celular <i class="text-secondary">(Opcional)</i></label>
							</div>
							<div class="form-floating mb-3">
								<input type="email" class="form-control rounded-1" id="floatingPassword" v-model="objectClientSendto.email">
								<label for="floatingPassword">Correo Electrónico <i class="text-secondary">(Opcional)</i></label>
							</div>
							<div class="form-floating mb-3">
								<input type="email" class="form-control rounded-1" id="floatingPassword" v-model="objectClientSendto.number_document">
								<label for="floatingPassword">RUT <i class="text-muted">(Opcional)</i></label>
							</div>
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" v-show="false" ref="btnCloseClientSendtoModal">Cerrar</button>
					    	<button class="w-100 mb-2 btn btn-lg rounded-3 btn-entity-alegria" type="submit" :disabled="!(objectClientSendto.sendto.trim().length > 2)" @click="nextSubscription">Continuar</button>
							<button class="w-100 mb-2 btn btn-lg rounded-3" data-bs-dismiss="modal" @click="goToHome()">Cancelar</button>
						</div>
      				</div>
    			</div>
  			</div>
		</div>

		<!-- Modal Resumen Suscripción -->
		<div class="modal fade" id="resumeSubscriptionModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" id="staticBackdropLabel">Resumen Suscripción</h4>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<table class="table table-sm table-hover table-responsive">
							<thead>
								<tr>
									<th class="text-center">Suscripción</th>
									<th class="text-center">Cantidad</th>
									<th class="text-center">Precio</th>
									<th class="text-center">Total</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in listProductsSelect" :key="index">
									<td>{{item.product}}</td>
									<td class="text-center">{{item.quantity}}</td>
									<td class="text-end">{{ price(item) | formatNumber }}</td>
									<td class="text-end">{{ price(item) * item.quantity | formatNumber }}</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<td class="text-end" colspan="3" >TOTAL: $</td>
									<td class="text-end"><strong>{{ totalSuscripcionProducts | formatNumber }}</strong></td>
								</tr>
							</tfoot>
						</table>

						<div class="card mb-2">
							<div class="card-body">
								<div class="title-width-icon">
									<h6 class="card-title text-center">Cargado a</h6>
								</div>
								<div>
									<svg class="text-secondary me-2" width="14" height="14"><use xlink:href="#person-badge"/></svg>
									<b class="align-middle text-secondary">{{ objectClientSendto.sendto }}</b>
								</div>
								<div v-if="objectClientSendto.email.trim() != ''">
									<svg class="text-secondary me-2" width="14" height="14"><use xlink:href="#envelope"/></svg>
									<b class="align-middle text-secondary">{{ objectClientSendto.email }}</b>
								</div>
								<div v-if="objectClientSendto.phone.trim() != ''">
									<svg class="text-secondary me-2" width="14" height="14"><use xlink:href="#phone"/></svg>
									<b class="align-middle text-secondary">{{ objectClientSendto.phone }}</b>
								</div>
								<div class="list-group-light p-0">
									<div class="list-group-item d-flex justify-content-between align-items-center mb-1">
										<div>
											<div class="fw-bold align-middle text-secondary">
												<svg class="text-secondary me-1" width="14" height="14"><use xlink:href="#building"/></svg>
												{{ church.type_church.name }} {{ church.name }}
											</div>
											<div class="ms-4 text-secondary">Distrito: {{ church.district.name }} ({{ church.entity.synthetic }})</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="alert alert-info" role="alert" v-if="getClientSystem.id != church.client_id">
							<h4 class="alert-heading">No olvide!</h4>
							<p>Las suscripciones seran enviadas a 
								<strong v-if="church.client != null && church.client != undefined">{{ church.client.name }} {{ church.client.surname }}</strong>
								<strong v-else class="text-danger">No está definido</strong>
								, <span class="text-primary" title="Coordinador de Publicaciones de la Iglesia Local">CPIL</span> de {{ church.type_church.name }} {{ church.name }}</p>
							<hr>
							<p class="mb-0"></p>El CPIL será informado de esta suscripción una vez que se haya pagado</p>
						</div>
					</div>					
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" ref="btnCloseResumeSubscriptionModal">Cerrar</button>
						<button type="button" class="btn btn-primary" @click="saveSubscriptionLocal" >Guardar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosAWN from '@/mixins/axiosAWN.js'

	import ClientSendtoInputComponent from '@/components/ClientSendtoInputComponent.vue'
	
	export default {
		name: 'NewSubscription',
		mixins: [mixin, axiosAWN],
		data() {
			return {
				listProducts: [],
				listTypeSubscriptions: [],
				churchId: 0,
				year: 0,
				objectClientSendto: {
					id: 0,
					sendto: '',
					phone: '',
					number_document: '',
					email: '',
					created_at: '',
					updated_at: ''
				},
				listClientSendtos: [],
				savingSubscription: false
			}
		},
		components: {
			'client-sendto-input-component': ClientSendtoInputComponent,
		},
		computed: {
            listProductsSelect() {
                let list = this.listProducts.filter(p => Math.trunc(Math.abs(p.quantity)) > 0)
                return list
            },
			newSubscription() {
                let data = {
                        client_id: this.getClientSystem.id,
                        church_id: this.churchId,
                        subscription_id: this.year,
                        products: this.listProductsSelect,
						client_sendto: this.objectClientSendto
                    }
				return data
			},
            totalSuscripcionProducts() {
                let total = this.listProducts.reduce((a, b) => { 
                                let c = Math.trunc(Math.abs(b.quantity)) * this.price(b)
                                return a + c
                            }, 0);
                return total.toFixed(0)
            },
			disabledBtnSaveSubscription() {
				if(this.savingSubscription)
					return true
				if(this.churchId == 0)
					return true
				if(this.getClientSystem.id == undefined || this.getClientSystem.id == 0)
					return true
				if(this.year == 0)
					return true
				if(this.totalSuscripcionProducts == 0)
					return true
				return false
			},
			church() {
				console.log(this.objectClientSendto.qwe)
				if(this.getClientSystem.extras.churchs != undefined && this.getClientSystem.extras.churchs != null && this.getClientSystem.extras.churchs.length > 0) {
					let index = this.getClientSystem.extras.churchs.map((el) => parseInt(el.id)).indexOf(parseInt(this.churchId))
					if(index > -1) {
						return this.getClientSystem.extras.churchs[index]
					}
				}
				return null
			}
		},
		methods: {
			initModuleLocal() {
				document.title = 'Nueva Suscripción - Suscripción ACES Chile'
				console.log('Estamos en el control de acceso (' + this.$el.className + ')')
				this.clearObjectClientSendto()
				if(this.getClientSystem.extras.churchs.length > 0) {
					this.churchId = this.getClientSystem.extras.churchs[0].id
				} 
				if(this.getClientSystem.extras.cpil) {
					this.getChurchClientSendtoLocal()
				} else {
					this.objectClientSendto.id = (this.getClientSystem.client_sendto_id != null) ? this.getClientSystem.client_sendto_id : 0
					this.objectClientSendto.sendto = this.getClientSystem.text
					this.objectClientSendto.phone = this.getClientSystem.phone
					this.objectClientSendto.email = this.getClientSystem.email
					this.objectClientSendto.number_document = this.getClientSystem.number_document
					this.checkOpenSubscriptionPeriod()
				}
			},
			clearObjectClientSendto() {
				this.objectClientSendto.id = 0
				this.objectClientSendto.sendto = ''
				this.objectClientSendto.phone = ''
				this.objectClientSendto.number_document = ''
				this.objectClientSendto.email = ''
				this.objectClientSendto.created_at = ''
				this.objectClientSendto.updated_at = ''
			},
			checkOpenSubscriptionPeriod() {
				this.setHeadersAuthorization(localStorage.getItem('token'))
				let url = this.getApiBackend + 'subscription/open'
				this.axiosAWNasyncBlock('Verificando periodos', 'POST', url, 'checkOpenSubscriptionPeriodResult', null)
			},
			checkOpenSubscriptionPeriodResult(response) {
				if(response.data.success) {
					this.setPeriod(response.data.data)
					this.year = this.getPeriod[0].id
					this.getTypeSubscriptionLocal()
				} else {
					this.checkOpenSubscriptionPeriodResultError(response.data)
				}
			},
			checkOpenSubscriptionPeriodResultError(error) {
				this.$awn.warning('No se pudo verificar el periodo de Suscripción abierto')
				this.setPeriod([])
				console.log(error)
				this.$router.push('/')
			},
			eventBlour(it) {
				if(isNaN(it.quantity))
					it.quantity = 0
                if(it.quantity == '')
                    it.quantity = 0
                it.quantity = Math.trunc(Math.abs(it.quantity))
            },
			getChurchClientSendtoLocal() {
				let url = this.getApiBackend + 'churchClientSendtos'
				let data = {
						churchId: this.churchId
					}
				this.axiosAWNasyncBlock('Buscando lista de suscriptores...', 'POST', url, 'getChurchClientSendtoLocalResult', data)
			},
			getChurchClientSendtoLocalResult(response) {
				if(response.data.success == true) {
					this.listClientSendtos = response.data.data
				}
				let clientSendto = {
						id: 0,
						sendto: '',
						number_document: '',
						phone: '',
						email: '',
						created_at: '',
						updated_at: ''
					}

				if(this.getClientSystem.client_sendto_id != null) {
					let index = this.listClientSendtos.map((el) => parseInt(el.id)).indexOf(parseInt(this.getClientSystem.client_sendto_id))
					if(index == -1) {
						clientSendto.id = this.getClientSystem.client_sendto.id
						clientSendto.sendto = this.getClientSystem.client_sendto.sendto
						clientSendto.number_document = this.getClientSystem.client_sendto.number_document
						clientSendto.phone = this.getClientSystem.client_sendto.phone
						clientSendto.email = this.getClientSystem.client_sendto.email
						clientSendto.created_at = this.getClientSystem.client_sendto.created_at
						clientSendto.updated_at = this.getClientSystem.client_sendto.updated_at
					}
				} else {
					clientSendto.id = -1
					clientSendto.sendto = this.getClientSystem.name + ' ' + this.getClientSystem.surname
					clientSendto.number_document = this.getClientSystem.number_document
					clientSendto.phone = this.getClientSystem.phone
					clientSendto.email = this.getClientSystem.email
				}

				if(clientSendto.id != 0) {
					this.listClientSendtos.push(clientSendto)
				}
				this.$refs.btnShowClientSendtoModal.click()
			},
			getChurchClientSendtoLocalResultError(error) {
				this.$awn.alert('No se pudo recuperar los Suscriptores')
				console.log(error)
			},
			getProductsLocal() {
				let url = this.getApiBackend + 'subscription/products'
				let data = {
						year: this.year
					}
				this.axiosAWNasyncBlock('Ahora estamos cargando los productos de la suscripción', 'POST', url, 'getProductsResult', data)
			},
			getProductsResult(response) {
				if(response.data.success) {
					this.listProducts = response.data.data
				} else {
					this.$awn.warning('Algo no salió bien, intentelo nuevamente')
				}
			},
			getProductsResultError(error) {
				this.$awn.alert('No se pudo recuperar los porductos')
				console.log(error)
			},
			getTypeSubscriptionLocal() {
				let url = this.getApiBackend + 'subscription/typeSubscription'
				let data = {
						year: this.year
					}
				this.axiosAWNasyncBlock('Estamos cargando los Tipos de Suscripciones', 'POST', url, 'getTypeSubscriptionResult', data)
			},
			getTypeSubscriptionResult(response) {
				if(response.data.success) {
					this.listTypeSubscriptions = response.data.data
					this.getProductsLocal()
				} else {
					this.getTypeSubscriptionResultError(response)
				}
			},
			getTypeSubscriptionResultError(error) {
				this.$awn.alert('No se pudo recuperar los tipos de suscripción')
				console.log(error)
			},
			nextSubscription() {
				this.$refs.btnCloseClientSendtoModal.click()
				if(this.listTypeSubscriptions.length == 0) {
					this.checkOpenSubscriptionPeriod()
				}
			},
			price(item) {
                let total = item.subscription_product.reduce(function(a, b) {
                                    let c = (b.status_id == 1) ? parseInt(b.price) : 0
                                return a + c
                            }, 0);
                return parseInt(total)
            },
			saveSubscriptionLocal() {
				if(!this.disabledBtnSaveSubscription) {
					this.savingSubscription = true
					let url = this.getApiBackend + 'subscription/save'
					this.axiosAWNasyncBlock('Estamos guardando la suscripción', 'POST', url, 'saveSubscriptionResult', this.newSubscription)
				}
			},
			saveSubscriptionResult(response) {
				if(response.data.success == true) {
					this.$awn.success('Suscripción guardada')
					this.$refs.btnCloseResumeSubscriptionModal.click()
					this.$router.push('/subscription/' + response.data.data.token)
				} else {
					this.saveSubscriptionResultError(response)
				}
			},
			saveSubscriptionResultError(error) {
				this.savingSubscription = false
				this.$awn.alert('No se pudo guardar la suscripción')
				console.log(error)
			},
			selectItemClientSendto(item) {
				this.objectClientSendto.id = item.item.id
				this.objectClientSendto.sendto = item.item.sendto
				this.objectClientSendto.phone = item.item.phone
				this.objectClientSendto.email = item.item.email
				this.objectClientSendto.number_document = item.item.number_document
				this.objectClientSendto.created_at = item.item.created_at
				this.objectClientSendto.updated_at = item.item.updated_at
			}
		},
		mounted () {
			this.initModule()
		}
	}
</script>

<style lang="scss">
	.table-subscription {
		width: 100%;
	}

	.table-subscription {
		tr:nth-child(even) {
			background-color: #f2f2f2;
		}
		tr {
			.quantity {
				width: 75px;
			}
			.total {
				width: 75px;
			}
		}
		tr {
			td {
				input {
					border: none;
					max-width: 75px;
					background-color: transparent;
				}
			}
			.price {
				width: 60px;
			}
		}
	}
</style>
